import { Component, Input } from '@angular/core';
import moment from 'moment';
import { Events } from 'ionic-angular';
/**
 * Generated class for the CoEventCardRegistrationStatusComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-event-card-registration-status',
  templateUrl: 'co-event-card-registration-status.html'
})
export class CoEventCardRegistrationStatusComponent {
  @Input('event') event;
  registrationStatus: string;
  closingSoon: boolean;
  isEventFull: boolean;
  constructor(private events: Events) {
  }

  ngOnInit() {
    this.initializeComp();
    this.events.subscribe('updateEventData', (event)=> {
      this.event = event
      this.initializeComp()
    })
  }

  initializeComp(){
    this.eventCheck(this.event);
    this.isClosingSoon(this.event.registrationCloses);
    this.eventFullCheck(this.event)

  }

  eventCheck(event: any) {
    if(!event.allowReg) {
      this.registrationStatus = 'noRegistration';
      return;
    }
    if(event.modifiedType == 'canceled') {
      this.registrationStatus = 'eventCanceled';
      return;
    }
    if(event.thirdPartyReg) {
      this.registrationStatus = 'thirdParty';
      return;
    }

    if(event.registrationOpens && moment(event.registrationOpens).isBefore('2000')) event.registrationOpens = false;

    if(moment().isBefore(event.registrationCloses)) {
      if(!event.registrationOpens || moment().isAfter(event.registrationOpens)) {
        this.checkRegistrants(event);
      }
      else if(moment().isBefore(event.registrationOpens)) {
        this.registrationStatus = 'notOpenYet';
      }
      else {
        this.registrationStatus = 'registrationClosed';
      }
    }
    else {
      this.registrationStatus = 'registrationClosed';
    }
  }

  checkRegistrants(event: any) {
    if (event.totalRegistrants >= event.maxAttendees) {
      this.registrationStatus = 'registrationFull';
    } else {
      this.registrationStatus = 'registrationOpen';
    }
  }

  isClosingSoon(event: any) {
    if (moment(event).subtract(2, 'day').isAfter(moment())) {
      this.closingSoon = true;
    } else {
      this.closingSoon = false;
    };
  }

  eventFullCheck(event) {
    let max = event.maxAttendees;
    let registered = event.totalRegistrants;
    if (max <= 10) {
      if (max - registered > 2) {
        this.isEventFull = true;
      } else {
        this.isEventFull = false;
      };
    } else if (max > 10) {
      if (registered / max < 0.9) {
        this.isEventFull = true;
      } else {
        this.isEventFull = false;
      };
    };
  };

}



// WEBPACK FOOTER //
// ./src/components/co-event-card-registration-status/co-event-card-registration-status.ts